import {lazyComponent} from 'coreUtils/adapters/lazy';

const ShareProductPopup = lazyComponent(() => import('./ShareProductPopup'));

export {ShareProductPopup as default};
